<script lang="ts">
  import '../app.css'
  import { goto } from '$app/navigation'
  import { resolve } from '$app/paths'
  import NavBar from '$lib/components/NavBar.svelte'
  import { auth } from '$lib/firebase'
  import { authUser, isAuthenticated } from '$lib/stores/authStore'
  import { initDatadog, logError } from '@tomra/datadog-browser-logging'
  import { onAuthStateChanged } from 'firebase/auth'
  import { onMount } from 'svelte'
  import { DATADOG_CONFIG, ENVIRONMENT, STAGE, VERSION } from '$lib/environment'
  import { initAmplitude } from '$lib/amplitudeUtils'
  import { page } from '$app/state'
  import type { Unsubscribe } from 'firebase/auth'
  import { Loader } from '@tomra/design-system-svelte'

  let { children } = $props()

  onMount(() => {
    let authUnsubscribe: Unsubscribe

    initDatadog({
      ...DATADOG_CONFIG,
      version: VERSION,
      env: `${ENVIRONMENT}.${STAGE}`,
      logSessionSampleRate: 100,
      sessionReplaySampleRate: 10,
      rumSessionSampleRate: 50,
      errorMsgIgnoreRegexList: [
        /Skipping view transition because/i,
        /Transition was aborted because of invalid state/i,
        /(XHR error|Fetch error).*\/index\.html/gi,
        /view transition aborted/gi,
        /AbortError: Fetch is aborted/i,
        /TypeError: Load failed/i,
        /Fetch error POST https:\/\/api-sr\.eu\.amplitude\.com\//i,
        /Fetch error GET https:\/\/sr-client-cfg\.eu\.amplitude\.com\//i
      ]
    })
    initAmplitude()

    isAuthenticated.set('tbd')

    auth.authStateReady().then(() => {
      authUnsubscribe = onAuthStateChanged(auth, async user => {
        try {
          authUser.set(user)

          if (user) {
            isAuthenticated.set('yes')

            if (page.url.pathname === '/login') {
              await goto(resolve('/'))
            }
          } else {
            isAuthenticated.set('no')
            await goto(resolve('/login'))
          }
        } catch (error) {
          logError(new Error('Failed to set auth user'), error as Error)
        }
      })
    })

    return () => {
      authUnsubscribe?.()
    }
  })
</script>

<NavBar />

{#if $isAuthenticated === 'tbd'}
  <div class="flex h-full items-center justify-center">
    <Loader variant="spinner" class="size-10" />
  </div>
{:else}
  <div id="content">
    {@render children()}
  </div>
{/if}
